<div>
  <button type="button" id="BtnPopup" (click)="GetIssueElementById()" style="display:none">Search</button>
  <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>
  <!--table-->
  <table #dataTable class="display" style="width:100%"></table>
</div>
<!--Action popup Page-->
<div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" id="modal_contentArt">
      <div class="modal-header" style="text-align:center">
        <h4 class="modal-title"> {{title}} </h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hide()"></button>
      </div>
      <!--popupbody-->
      <div class="modal-body" id="popupbody">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-6">
              Elements<em>*</em>
              <select id="ddlElements" class="form-control">
                <option *ngFor="let item of GetElements" value={{item.Elements}}>
                  {{item.Elements}}
                </option>
              </select>
            </div>
            <div class="col-sm-6">
             Group Name<em>*</em>
              <select id="ddlGroupName" class="form-control">
                <option *ngFor="let item of GetGroupName" value={{item.GroupName}}>
                  {{item.GroupName}}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-6">
              FileType<em>*</em>
              <input id="Txt_FileType" type="text" maxlength="50" class="form-control" autocomplete="off">
            </div>
            <div class="col-sm-6">
              FileName<em>*</em>
              <input id="Txt_FileFormat" type="text" class="form-control" maxlength="225" autocomplete="off">
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-6" name="SelectionMode">
              Selection Mode<em>*</em>
              <select class="form-control" id="ddlSelectionMode">
                <option value="Single" selected="selected">Single</option>
                <option value="Multiple">Multiple</option>
              </select>
            </div>
            <div class="col-sm-6">
              Pages<em>*</em>
              <input id="Txt_Pages" type="number" class="form-control" maxlength="6" autocomplete="off">
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-4">
              IsMandatory
              <input id="Txt_IsMandatory" type="checkbox" autocomplete="off">
            </div>
          </div>
        </div>
      </div>
      <!--popup body end-->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
        <button type="button" class="btn btn-outline-success waves-effect waves-light" title="{{popUpButtonText}}" id="btnWF" (click)="UpdateTemplate()"> {{popUpButtonText}} </button>
      </div>
      <div id="LoadingImagePopup">
        <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
      </div>
    </div>
  </div>
</div>
